import { z } from 'zod';
/** Запрос на сброс пароля по email. */
export const requestPasswordResetSchema = z.object({
    email: z.string().email('Некорректный email').max(255),
});
/** Установка нового пароля по одноразовому токену из email. */
export const resetPasswordSchema = z.object({
    token: z.string().min(10),
    newPassword: z
        .string()
        .min(8, 'Минимум 8 символов')
        .max(128)
        .refine((v) => /[A-ZА-Я]/.test(v), 'Хотя бы одна заглавная буква')
        .refine((v) => /\d/.test(v), 'Хотя бы одна цифра')
        .refine((v) => /[^A-Za-zА-Яа-я0-9]/.test(v), 'Хотя бы один спецсимвол'),
});
/**
 * Ответ обоих endpoints — нейтральный.
 * Для request-password-reset: всегда `ok: true` (anti-enumeration — не
 * палим существование email).
 */
export const passwordResetResponseSchema = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=auth-reset.js.map